import { SAVE_ALL_CONTACTS } from "./types"

const saveAllContacts = (datas) => {
	return{
		type: SAVE_ALL_CONTACTS,
		payload: datas
	}
}

export { saveAllContacts }